/** Öffnet das Lead-Modal auf der Startseite (t05 Landing). */
export function navigateToLeadForm(interest?: string): void {
  const params = new URLSearchParams({ openLead: '1' });
  if (interest?.trim()) {
    params.set('interest', interest.trim());
  }
  window.location.href = `/?${params.toString()}`;
}

/**
 * Pricing-CTAs bis Stripe live: Startseite.
 * TODO(Stripe): durch Checkout-URL oder /preise ersetzen.
 */
export function navigateToHomePricing(): void {
  window.location.href = '/';
}
